import { render, staticRenderFns } from "./ConfirmationRegisterModal.vue?vue&type=template&id=c6570270&scoped=true"
import script from "./ConfirmationRegisterModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationRegisterModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationRegisterModal.vue?vue&type=style&index=0&id=c6570270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6570270",
  null
  
)

export default component.exports